import Dropdown from "./../../Dropdown/Dropdown";
import { getProgramData, serviceDivisionPractice } from "../../../Services/Service";
import { useEffect, useState } from "react";
import DatePicker from "./DatePicker";
import { defaultOneMonthDate } from "../../../Services/commonFun";

export default ({
  onGo,
  setActiveUsersLoading,
  setFetchServicePatientDataLoading,
  setFetchSuperviewCallDetailLoading,
  setFetchSuperviewMesageGraphLoading,
  setfetchSuperviewInclinicCallLoading,
  setCoachRatingLoading,
  setSeriesGraph,
  title = "Super Admin Overview",
}) => {
  const [programes, setProgrames] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [clinics, setClinics] = useState([]);

  const { today, lastMonth } = defaultOneMonthDate();

  // const [dateFilter, setDateFilter] = useState([]);

  // const [startRange, setStartRange] = useState("");
  // const [endRange, setEndRange] = useState("");
  const [programSelect, setProgramSelect] = useState("");
  const [divisionSelected, setDivisionSelected] = useState([]);
  const [clinicSelect, setClinicSelect] = useState([]);
  const [recent, setRecent] = useState([]);
  const [range, setRange] = useState({
    startDate: lastMonth,
    endDate: today,
  });

  const [tempDivision,setTempDivison] = useState([]);

  // 2025-06-15 to 2025-07-14
  // 06/15/2025 to 07/14/2025

  useEffect(()=>{
    if(!programSelect){
      emptyProgramSetValues(tempDivision);
   
    }
  },[tempDivision])

  // useEffect(()=>{
  //    setClinicSelect([]);
  // },[divisionSelected])

  useEffect(() => {
    fetchDivsionPractice();
    handleLoadAllProgrames();
    loadRecent();
  }, []);

  // useEffect(() => {
  //   if(programSelect){

  //     const _divisions = (
  //       programes.find((i) => i.programId == programSelect)?.areas ?? []
  //     )
  //     .filter((i) => i.areaName != "")
  //     .map((i) => {
  //       return {
  //         checked: false,
  //         children: [],
  //         label: i.areaName,
  //         value: i.areaId,
  //         _id: i.areaId,
  //         clinics: i.clinics,
  //       };
  //     });
      
  //     setDivisionSelected([]);
  //     setDivisions(_divisions);
  //   }else{
  //     setDivisionSelected([]);
  //     setClinicSelect([]);
  //     emptyProgramSetValues(tempDivision)
  //   }
  // }, [programSelect]);

  useEffect(() => {
    if(divisionSelected.length==0){
       emptyProgramSetValues(tempDivision);
    }else{
      const _clinics = divisions
      .filter((p) => divisionSelected.includes(p.value)) // filter selected
      .flatMap((p) => p.clinics)
      .filter((i) => i.clinicName != "")
      .map((i) => {
        return {
          checked: false,
          children: [],
          label: i.label,
          value: i.value,
          _id: i.value,
        };
      });
    setClinics(_clinics);
    setClinicSelect([]);
    }
    
  }, [divisionSelected]);

  
  const fetchDivsionPractice = async () => {
      await serviceDivisionPractice().then((res) => {
        if (res.data.code == 200) {
          setTempDivison(res.data.data);
          console.log("Division Practice Data:", res.data.data);
          const _divisions = res.data.data
          .map((i) => i.value);
          const _clinics = res.data.data
          .flatMap(p => p.children)
          .map((i) => i.value);
          let data = {
            startRange: range.startDate,
            endRange: range.endDate,
            programSelect,
            divisionSelected:_divisions,
            clinicSelect:_clinics,
            divisionClinicFilter: {
              clinic: _clinics,
              division: _divisions,
            },
          };
          onGo && onGo(data);
        }
      });
    };

  const handleLoadAllProgrames = async () => {
    try {
      const programResponse = await getProgramData();
      if (programResponse.status == 200 && programResponse.data.code == 200) {
        const _programes = programResponse.data.data.filter(
          (i) => i.programName != ""
        );
        setProgrames(_programes);
      }
    } catch (e) {
      console.log(e.message);
    }
  };

  const emptyClinicValue = (_divisions) => {
    const _clinics = _divisions
      .flatMap(p => p.clinics)
      .map((i) => {
        return {
          checked: false,
          children: [],
          label: i.label,
          value: i.value,
          _id: i.value
        };
      });
      
    setClinics(_clinics);
  }
  const emptyProgramSetValues = (divisions) => {
     const _divisions = divisions
      .map((i) => {
        return {
          checked: false,
          children: [],
          label: i.label,
          value: i.value,
          _id: i.value,
          clinics: i.children
        };
      });
    setDivisions(_divisions);
    emptyClinicValue(_divisions);
  }

  const nodeToggle = (cuurentNode) => {
    
  };
  const handleDropDownChange = (currentNode) => {
    const value = currentNode.value;
    let selecedData = [];
    if (value == "toggleSelectAll") {
      if (currentNode.checked) {
        setDivisionSelected(divisions.map((i) => i.value));
        selecedData = divisions.map((i) => {
          return {
            ...i,
            checked: true,
          };
        });
      } else {
        selecedData = divisions.map((i) => {
          return {
            ...i,
            checked: false,
          };
        });
        setDivisionSelected([]);
      }
    } else {
      let selected = [...divisionSelected];
      const isExists = selected.includes(value);
      if (isExists) {
        selected = selected.filter((j) => j != value);
      } else {
        selected.push(value);
      }
      setDivisionSelected(selected);
      selecedData = divisions.map((i) => {
        i.checked = selected.includes(i.value);
        return i;
      });
    }
    setDivisions(selecedData);
  };
  const handleDropDownChange2 = (currentNode) => {
    const value = currentNode.value;
    let selecedData = [];
    if (value == "toggleSelectAll") {
      if (currentNode.checked) {
        setClinicSelect(clinics.map((i) => i.value));
        selecedData = clinics.map((i) => {
          return {
            ...i,
            checked: true,
          };
        });
      } else {
        selecedData = clinics.map((i) => {
          return {
            ...i,
            checked: false,
          };
        });
        setClinicSelect([]);
      }
    } else {
      let selected = [...clinicSelect];
      const isExists = selected.includes(value);
      if (isExists) {
        selected = selected.filter((j) => j != value);
      } else {
        selected.push(value);
      }
      setClinicSelect(selected);
      selecedData = clinics.map((i) => {
        i.checked = selected.includes(i.value);
        return i;
      });
    }

    setClinics(selecedData);
  };

  const finalSubmit = (_data)=>{
    // console.log(data)
    let data = {..._data};
    let _divisionSelected=[];
    let clinicSelected=[];
    // if(data.programSelect == ""){
    //   // console.log(divisionSelected.length);
      
    // }
    const divisionSelectedLength = _data.divisionClinicFilter.division.length;
    const clinicSelectLength = _data.divisionClinicFilter.clinic.length;
    if(divisionSelectedLength==0 && clinicSelectLength==0){
        _divisionSelected = tempDivision.map((i)=>i.value)
        clinicSelected = tempDivision.flatMap((i)=>i.children).map((i)=>i.value);       
        data.clinicSelect = clinicSelected; 
        data.divisionSelected = _divisionSelected; 
        data.divisionClinicFilter = {
          clinic: clinicSelected,
          division: _divisionSelected,
        };
      }else if(divisionSelectedLength!=0 && clinicSelectLength==0){
        
        clinicSelected = tempDivision.filter((i)=>data.divisionSelected.includes(i.value)).flatMap((i)=>i.children).map((i)=>i.value);
        data.clinicSelect = clinicSelected;
        data.divisionClinicFilter = {
          clinic: clinicSelected,
          division: data.divisionSelected,
        };
      }
    // console.log(data);
    // console.log(_data);
    onGo && onGo(data);
  } 

  const handleClear = () => {

    // if (!programSelect && !range.startDate && !range.endDate) {
    //   return;
    // }

    setActiveUsersLoading && setActiveUsersLoading(true);
    setFetchServicePatientDataLoading && setFetchServicePatientDataLoading(true);
    setFetchSuperviewCallDetailLoading && setFetchSuperviewCallDetailLoading(true);
    setFetchSuperviewMesageGraphLoading && setFetchSuperviewMesageGraphLoading(true);
    setfetchSuperviewInclinicCallLoading && setfetchSuperviewInclinicCallLoading(true);
    setCoachRatingLoading && setCoachRatingLoading(true);
    setSeriesGraph && setSeriesGraph((prev) => {
      return {
        ...prev,
        loadingStates: {
          program_graph: true,
          gender_age_graph: true,
          division_graph: true,
          division_practice_graph: true,
          division_date_graph: true,
          inclinic_call_graph: true,
          call_detail_graph: true,
          message_graph: true,
        },
      };
    });
    setRange({
      startDate: "",
      endDate: "",
    });
    setProgramSelect("");
    setClinicSelect([]);
    setDivisionSelected([]);

   
      finalSubmit({
        startRange: "",
        endRange: "",
        programSelect: "",
        divisionSelected: [],
        clinicSelect: [],

        divisionClinicFilter: {
          clinic: [],
          division: [],
        },
      });
  };

  const handleSubmit = async () => {
    //make all filter forms loading true here

    setActiveUsersLoading && setActiveUsersLoading(true);
    setFetchServicePatientDataLoading && setFetchServicePatientDataLoading(true);
    setFetchSuperviewCallDetailLoading && setFetchSuperviewCallDetailLoading(true);
    setFetchSuperviewMesageGraphLoading && setFetchSuperviewMesageGraphLoading(true);
    setfetchSuperviewInclinicCallLoading && setfetchSuperviewInclinicCallLoading(true);
    setCoachRatingLoading && setCoachRatingLoading(true);
    setSeriesGraph && setSeriesGraph((prev) => {
      return {
        ...prev,
        loadingStates: {
          program_graph: true,
          gender_age_graph: true,
          division_graph: true,
          division_practice_graph: true,
          division_date_graph: true,
          inclinic_call_graph: true,
          call_detail_graph: true,
          message_graph: true,
        },
      };
    });

    let _recent = (await localStorage.getItem("recent")) ?? "[]";
    _recent = JSON.parse(_recent);

    let data = {
      startRange: range.startDate,
      endRange: range.endDate,
      programSelect,
      divisionSelected,
      clinicSelect,
      divisionClinicFilter: {
        clinic: clinicSelect,
        division: divisionSelected,
      },
    };
    // console.log('click')
    finalSubmit(data);
    loadRecent(data);
  };

  const loadRecent = async (data = null) => {
    let _recent = JSON.parse(localStorage.getItem("recent") ?? "[]");

    if (data && programSelect) {
      data.name =
        programes.find((i) => i.programId == programSelect)?.programName ?? "";
      if (data.name) {
        // Remove duplicate by a unique key, e.g., data.id or data.url
        _recent = _recent.filter((item) => item.name !== data.name); // replace `id` with your key
        // Add new item to the beginning
        _recent.unshift(data);
        // Limit to 5
        _recent = _recent.slice(0, 5);
        // Save back
        await localStorage.setItem("recent", JSON.stringify(_recent));
      }
    }
    setRecent(_recent);
  };

  const handleRemove = (event, index) => {
    event.stopPropagation();
    let newData = [...recent];
    newData.splice(index, 1);
    localStorage.setItem("recent", JSON.stringify(newData));
    setRecent(newData);
  };

  const handleRecentOpen = (event, data) => {
    try {
      finalSubmit(data);
      setProgramSelect(data.programSelect);
      setTimeout(() => {
        setDivisionSelected(data.divisionSelected);
        setTimeout(() => {
          setClinicSelect(data.clinicSelect);
        }, 200);
      }, 200);
      setRange((prev) => {
        return {
          ...prev,
          startDate: data.startRange,
          endDate: data.endRange,
        };
      });
    } catch (e) {
      console.log(e.message);
    }
  };
  const divisionSelectedLength = divisionSelected.length;
  const clinicSelectLength = clinicSelect.length;
  return (
    <>
      {/* {JSON.stringify(range)} */}
      <div className="row">
        <div className="col-md">
          <h1 className="title"> {title}</h1>
        </div>

        <div className="col-md-2 pe-1">
          <select
            id="programSelect"
            name="programSelect"
            value={programSelect} // must be scalar (string or number)
            className="form-select form-select-sm"
            required
            onChange={(event) => setProgramSelect(event.target.value)}
          >
            <option value="">Select Program</option>
            {programes.map((data, i) => (
              <option
                value={String(data.programId)} // ensure it's a string or number
                key={`select_item_${i}`}
              >
                {data.programName}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-2 pe-0">
          <Dropdown
            placeholder={
              divisionSelectedLength > 0
                ? `${divisionSelectedLength} Divisions Selected`
                : "Select Division"
            }
            data={[
              {
                label: "Select All",
                value: "toggleSelectAll",
                _toggleSelectAll: true,
                checked:
                  divisionSelectedLength > 0
                    ? divisionSelectedLength == divisions.length
                    : false,
              },
              ...divisions.map((i) => {
                i.checked = divisionSelected.includes(i.value);
                return i;
              }),
            ]}
            onChange={handleDropDownChange}
            nodeToggle={nodeToggle}
          />
        </div>
        <div className="col-md-2 pe-0">
          <Dropdown
            placeholder={
              clinicSelectLength > 0
                ? `${clinicSelectLength} Practices Selected`
                : "Select Practices"
            }
            data={[
              {
                label: "Select All",
                value: "toggleSelectAll",
                _toggleSelectAll: true,
                checked:
                  clinicSelectLength > 0
                    ? clinicSelectLength == clinics.length
                    : false,
              },
              ...clinics.map((i) => {
                i.checked = clinicSelect.includes(i.value);
                return i;
              }),
            ]}
            onChange={handleDropDownChange2}
            nodeToggle={nodeToggle}
          />
        </div>
        <div className="col-md-auto pe-1">
          {/* <DateRangeComp
                typeofdate="blank"
                filterParam={{ 
                  smsStartFilter: startRange, 
                  smsEndFilter: endRange 
                }}
                dateFilter={dateFilter}
                onClick={getData}
              /> */}
          <DatePicker value={range} onChange={setRange} />
        </div>

        <div className="col-md-auto ps-0">
          <button
            type="button"
            className="btn btn-success btn-sm"
            onClick={()=>handleSubmit()}
          >
            Go
          </button>
        </div>
        <div className="col-md-auto ps-0">
          <button
            type="button"
            className="btn btn-success btn-sm"
            onClick={handleClear}
          >
            Clear
          </button>
          &nbsp;&nbsp;
        </div>
      </div>
      <div className={`row mt-4 ${recent.length == 0 && "d-none"}`}>
        <div className="col-auto mr-2">Recent</div>
        {recent.map((item, index) => (
          <div
            key={`recent_${index}`}
            onClick={(e) => handleRecentOpen(e, item)}
            className="col-auto d-flex align-items-center mb-1"
            style={{
              borderRadius: 5,
              background: "#f3f6fc",
              marginRight: 10,
              cursor: "pointer",
            }}
          >
            <span className="pr-2">{item.name}</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              onClick={(e) => handleRemove(e, index)}
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              style={{ height: 18, marginLeft: 4 }}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18 18 6M6 6l12 12"
              />
            </svg>
          </div>
        ))}
      </div>
    </>
  );
};
